/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/rules-of-hooks */

import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import Layout from 'components/Layout';
import Button, { ButtonContainer } from 'components/Button';
import StepNavigation from 'components/StepNavigation'
import {
    FileModal
} from '@fitinsur/components';
import {
    Content,
    ButtonContent
} from './styles';
import Row from "components/Grid/Row";
import Col from "components/Grid/Col";
import BrokingSummary from 'components/BrokingSummary';
import { LoaderContext } from '@fitinsur/contexts';
import { useGetDocuments } from 'services/DocumentsService';
import { useGetOperationAsync } from 'services/OperationService';

export default function QuoteDocument({ match }) {
    const { updateIsLoadingStatus } = useContext(LoaderContext);
    const history = useHistory();
    const formikRef = useRef({});
    const handleBack = () => history.goBack();

    const [operation, setOperation] = useState({});
    const [documents, setDocuments] = useState([])

    const {
        data: useGetDocumentsData,
        loading: useGetDocumentsLoading,
        error: useGetDocumentsError,
        status: useGetDocumentsStatus,
        request: useGetDocumentsRequest
    } = useGetDocuments(match.params?.idOperation);

    const {
        loading: useGetOperationLoading,
        request: useGetOperationRequest
    } = useGetOperationAsync(match.params?.idOperation);

    useEffect(() => {
        handleOperationInfo();
        useGetDocumentsRequest(null, { idDomain: 261 })
    }, []);


    const handleOperationInfo = () => {
        useGetOperationRequest(null, { loadLastDocument: true }).then(response => {
            let operationData;
            if (response.status === 200) {
                operationData = response.data?.value;
                setOperation(operationData);
            }
        });
    }

    useEffect(() => {
        updateIsLoadingStatus(useGetDocumentsLoading || useGetOperationLoading);
    }, [useGetDocumentsLoading, useGetOperationLoading]);

    useEffect(() => {
        if (!useGetDocumentsStatus) return;
        if (useGetDocumentsStatus === 200) {
            const [quoteRequestDocument] = useGetDocumentsData.value;
            if (quoteRequestDocument) {
                setDocuments([{
                    idDocument: quoteRequestDocument.idDocument,
                    idDomainDescription: quoteRequestDocument.idDomainDescription,
                    idReport: quoteRequestDocument.idReport,
                    idOperation: quoteRequestDocument.idOperation,
                    reportToken: quoteRequestDocument.reportToken,
                    fileName: quoteRequestDocument.documentMetadata.fileName
                }])
            }
        }
    }, [useGetDocumentsStatus]);

    return (
        <Layout
            title={""}
            subtitle={operation?.idOperation}
        >
            <Row>
                <Col>
                    <StepNavigation stage={2} idOperation={match.params?.idOperation} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <BrokingSummary
                        history={history}
                        idOperation={match?.params?.idOperation}
                    />
                </Col>
            </Row>

            <Content>
                <Formik
                    innerRef={formikRef}
                    initialValues={{}}
                    enableReinitialize={true}
                >
                    {() => (
                        <Form>
                            <FileModal documents={documents} />

                            <ButtonContainer>
                                <Button forth style={{ width: 'auto' }} onClick={() => handleBack()}> &lt; VOLTAR </Button>
                                <ButtonContent>
                                    <Button
                                        type="button"
                                        onClick={() => history.push(`/quote/plans/${operation?.idProduct || 34}/${match.params?.idOperation}`)}
                                        third
                                    >
                                        TELA DE PLANOS
                                    </Button>
                                </ButtonContent>
                            </ButtonContainer>
                        </Form>
                    )}
                </Formik>
            </Content>
        </Layout >
    )
}